import react from 'react';
import reactDOM from 'react-dom';
import bookSearch from './components/BookSearch';
import quickCategory from './components/QuickCategory';
import bookDetail from './components/BookDetail';
import counting from './components/Counting';
import newBooksInMonth from './components/NewBooksInMonth';
import bookNewsSNP from './components/BookNews';
import bookInfo from './components/BookSearch/BookInfo';
import registerForm from './components/RegisterForm/RegisterForm';
import bookSerchByType from './components/BookSearchByType';

import {
  SchoolGradeOlogy as schoolGradeOlogy,
  SchoolOlogyBooks as schoolOlogyBooks,
} from './components/SchoolGradeOlogy';
import './main.css';
import 'antd/dist/antd.css';

export const BookSearch = bookSearch;
export const QuickCategory = quickCategory;
export const SchoolGradeOlogy = schoolGradeOlogy;
export const SchoolOlogyBooks = schoolOlogyBooks;
export const BookDetail = bookDetail;
export const BookNewsSNP = bookNewsSNP;
export const NewBooksInMonth = newBooksInMonth;
export const Counting = counting;
export const BookInfo = bookInfo;
export const RegisterForm = registerForm;
export const BookSerchByType = bookSerchByType

export const React = react;
export const ReactDOM = reactDOM;

// ReactDOM.render(<App />, document.getElementById("app"));
